const MARGIN = 8
const LEFT_MARGIN = 16

export type AnchorOrigin = {
  vertical: 'top' | 'bottom'
  horizontal: 'left' | 'right' | 'center'
}

/**
 * Calculates fixed position for popover content relative to anchor element.
 * Reuses the same viewport-clamping approach as SelectList.
 */
export function getPopoverPosition(
  anchorRect: DOMRect,
  popoverWidth: number,
  popoverHeight: number,
  anchorOrigin: AnchorOrigin,
  distanceFromAnchor: number = MARGIN
): { top: number; left: number } {
  const viewportWidth = window.innerWidth
  const viewportHeight = window.innerHeight

  let top: number

  if (anchorOrigin.vertical === 'bottom') {
    top = anchorRect.bottom + distanceFromAnchor
  } else {
    top = anchorRect.top - popoverHeight - distanceFromAnchor
  }

  let left: number

  switch (anchorOrigin.horizontal) {
    case 'left':
      left = anchorRect.left
      break
    case 'right':
      left = anchorRect.right - popoverWidth
      break
    case 'center':
    default:
      left = anchorRect.left + (anchorRect.width - popoverWidth) / 2
      break
  }

  // Clamp to viewport
  top = Math.max(top, MARGIN)
  top = Math.min(top, viewportHeight - popoverHeight - MARGIN)
  left = Math.max(left, LEFT_MARGIN)
  left = Math.min(left, viewportWidth - popoverWidth - LEFT_MARGIN)

  return { top, left }
}
